import request from '@/utils/request'

export function getEnrollment(params) {
  return request({
    url: '/statistics/enrollment',
    method: 'get',
    params
  })
}
